/** Turkish. Same keys as English (see en.ts). */
export const tr: Record<string, string> = {
  'app.title': 'Spin the Bottle',

  'common.ok': 'Tamam',
  'common.cancel': 'İptal',
  'common.close': 'Kapat',
  'common.back': 'Geri',
  'common.retry': 'Tekrar dene',
  'common.save': 'Kaydet',
  'common.send': 'Gönder',
  'common.loading': 'Yükleniyor…',
  'common.reconnecting': 'Bağlantı koptu. Yeniden bağlanılıyor…',
  'common.offline': 'Çevrimdışısın',
  'common.hearts': '❤ {count}',
  'common.optional': 'isteğe bağlı',

  'errors.BAD_REQUEST': 'Bu istekte bir sorun var.',
  'errors.VALIDATION_FAILED': 'Girdiklerini kontrol et.',
  'errors.UNAUTHORIZED': 'Oyunu Telegram’dan yeniden aç.',
  'errors.TOKEN_EXPIRED': 'Oturumun süresi doldu. Yeniden bağlanılıyor…',
  'errors.FORBIDDEN': 'Bunu yapamazsın.',
  'errors.NOT_FOUND': 'Bulunamadı.',
  'errors.CONFLICT': 'Bu başka biri tarafından değiştirildi. Tekrar dene.',
  'errors.UNPROCESSABLE': 'Bu işlem şu anda mümkün değil.',
  'errors.RATE_LIMITED': 'Çok hızlı! Biraz bekle.',
  'errors.PAYLOAD_TOO_LARGE': 'Bu çok uzun.',
  'errors.UNIQUE_VIOLATION': 'Bu zaten var.',
  'errors.INTERNAL_ERROR': 'Bir şeyler ters gitti. Tekrar dene.',
  'errors.SERVICE_UNAVAILABLE': 'Oyun yeniden başlatılıyor. Birazdan döner.',
  'errors.INIT_DATA_INVALID': 'Oyunu Telegram botundan aç.',
  'errors.INIT_DATA_EXPIRED': 'Bu bağlantı çok eski. Oyunu bottan yeniden aç.',
  'errors.BANNED': 'Hesabın engellendi.',
  'errors.ONBOARDING_REQUIRED': 'Önce profilini tamamla.',
  'errors.SESSION_REPLACED': 'Oyun başka bir cihazda açıldı.',
  'errors.LOGIN_FAILED': 'Kullanıcı adı veya şifre yanlış.',
  'errors.WRONG_PASSWORD': 'Mevcut şifre yanlış.',
  'errors.ROOM_NOT_FOUND': 'Bu masa artık yok.',
  'errors.ROOM_FULL': 'Bu masa dolu.',
  'errors.ROOM_BUSY': 'Masa meşgul. Tekrar dene.',
  'errors.NOT_IN_ROOM': 'Bir masada değilsin.',
  'errors.NOT_YOUR_TURN': 'Sıra sende değil.',
  'errors.NOT_IN_ROUND': 'Bu turda değilsin.',
  'errors.STALE_TURN': 'Bunun için çok geç.',
  'errors.ALREADY_DECIDED': 'Zaten karar verdin.',
  'errors.MUTED': 'Şu anda sohbet edemezsin.',
  'errors.BLOCKED': 'Bu oyuncuyla etkileşime giremezsin.',
  'errors.MESSAGE_REJECTED': 'Bu mesaj gönderilemez. Bağlantılar ve kaba sözler yasak.',
  'errors.CANNOT_TARGET_SELF': 'Bunu kendine yapamazsın.',
  'errors.INSUFFICIENT_FUNDS': 'Yeterli kalbin yok.',
  'errors.INSUFFICIENT_GM': 'Yeterli GM yok.',
  'errors.TRANSFER_LIMIT': 'Bugün yeterince gönderdin. Yarın tekrar dene.',
  'errors.NOT_FRIENDS': 'Sadece arkadaşlarına gönderebilirsin.',
  'errors.ALREADY_CLAIMED': 'Bugün zaten aldın. Yarın tekrar gel!',
  'errors.GIFT_NOT_FOUND': 'Bu hediye mevcut değil.',
  'errors.VIDEO_UNAVAILABLE': 'Bu video oyunda oynatılamıyor. Başka bir bağlantı dene.',
  'errors.NO_CHANCES': 'Hiç şansın kalmadı.',
  'errors.NO_BOOSTER': 'Bu güçlendiricin yok.',
  'errors.PRODUCT_NOT_FOUND': 'Bu paket mevcut değil.',

  'gender.MALE': 'Erkek',
  'gender.FEMALE': 'Kadın',
  'locale.en': 'English',
  'locale.ru': 'Русский',
  'locale.uz': 'Oʻzbekcha',
  'locale.az': 'Azərbaycanca',
  'locale.tr': 'Türkçe',

  'onboarding.title': 'Spin the Bottle’a hoş geldin!',
  'onboarding.subtitle': 'Şişeyi çevir, öpüş, hediye gönder ve yeni insanlarla tanış.',
  'onboarding.language': 'Dil',
  'onboarding.name': 'Masadaki adın',
  'onboarding.gender': 'Cinsiyetim',
  'onboarding.birth_year': 'Doğum yılı',
  'onboarding.birth_year_hint': 'Adının yanında yaşın olarak gösterilir',
  'onboarding.rules_title': 'Masa kuralları',
  'onboarding.rule_respect': 'Kibar ol. Hakaret, spam ve bağlantılar yasak.',
  'onboarding.rule_virtual': 'Öpücükler ve hediyeler sanaldır, sadece eğlence için.',
  'onboarding.rule_block': 'İstediğin zaman herkesi engelleyebilir veya şikayet edebilirsin.',
  'onboarding.adult': '18 yaşında veya daha büyüğüm ve masa kurallarını kabul ediyorum',
  'onboarding.start': 'Hadi oynayalım',
  'onboarding.underage': 'Üzgünüz, oyun yalnızca 18 yaş ve üzeri oyuncular için.',

  'lobby.play': 'PLAY',
  'lobby.balance': 'Kalplerin',
  'lobby.ratings': 'Sıralamalar',
  'lobby.achievements': 'Başarımlar',
  'lobby.shop': 'Kalp satın al',
  'lobby.settings': 'Ayarlar',
  'lobby.invite': 'Arkadaşlarını davet et',
  'lobby.profile': 'Profil',

  'table.title': 'Masa {code}',
  'table.waiting_players': 'Daha fazla oyuncu bekleniyor…',
  'table.waiting_turn': 'Sıradaki tur bekleniyor',
  'table.your_turn': 'Şişeyi çevir!',
  'table.tap_bottle': 'Şişeye dokun',
  'table.spins': 'Şişeyi çeviriyor',
  'table.your_choice': 'Senin seçimin',
  'table.kiss_back': 'Geri öpecek mi?',
  'table.will_they': 'Öpüşecekler mi?',
  'table.kiss': 'Öp',
  'table.refuse': 'Reddet',
  'table.result_mutual': 'Karşılıklı öpücük! 💋',
  'table.result_one': '{from}, {to} adlı oyuncuyu öptü 💋',
  'table.result_none': 'Bu sefer öpücük yok',
  'table.change': 'Masayı değiştir',
  'table.leave': 'Masadan ayrıl',
  'table.chat_placeholder': 'Bir mesaj yaz',
  'table.chat_empty': 'Herkese merhaba de 👋',
  'table.music_on': 'Müzik açık',
  'table.music_off': 'Müzik kapalı',
  'table.now_playing': 'Şimdi çalıyor',
  'table.tap_to_listen': 'Dinlemek için dokun',
  'table.music_error': 'Bu video burada oynatılamıyor',
  'table.dj_title': 'Masa için şarkı ısmarla',
  'table.dj_hint': 'Bir YouTube bağlantısı yapıştır. Masadaki herkes duyacak.',
  'table.dj_order': '❤ {price} karşılığında ısmarla',
  'table.dj_queue': 'Sırada: {count}',
  'table.idle_kicked': 'Hareketsiz kaldığın için masadan çıkarıldın.',
  'table.session_replaced': 'Oyun başka bir cihazda açıldı.',
  'table.kisses.one': '{count} öpücük',
  'table.kisses.other': '{count} öpücük',
  'table.joined': '{name} masaya katıldı',
  'table.left': '{name} masadan ayrıldı',
  'table.gift_sent': '{from}, {to} için {emoji} gönderdi',
  'table.dj_dedicated': '{name}, {to} için bir şarkı armağan etti: {title}',
  'table.dj_for': '{name} için',
  'table.dj_dedicate': '{name} için şarkı armağan et',
  'table.dj_video': 'Klip olarak göster (❤ {price})',
  'gifts.category.romance': 'Romantik',
  'gifts.category.hats': 'Şapkalar ve taçlar',
  'gifts.category.animals': 'Hayvanlar',
  'gifts.category.music': 'Müzik',
  'gifts.category.vip': 'VIP',
  'table.dj_ordered': '{name} bir şarkı ısmarladı: {title}',

  'player.send_gift': 'Hediye gönder',
  'player.hidden_message': 'Gizli mesaj',
  'player.dare': 'Cesaret görevi',
  'player.admire': '❤ {price} ile hayran ol',
  'player.admirer': 'Hayranı: {name} (❤ {price})',
  'player.no_admirer': 'Henüz hayranı yok',
  'player.block': 'Engelle',
  'player.unblock': 'Engeli kaldır',
  'player.report': 'Şikayet et',
  'player.you': 'Bu sensin',
  'player.achievements.one': '{count} başarım',
  'player.achievements.other': '{count} başarım',

  'gifts.title': '{name} için hediye',
  'gifts.category.flowers': 'Çiçekler',
  'gifts.category.drinks': 'İçecekler',
  'gifts.category.sweets': 'Tatlılar',
  'gifts.category.fun': 'Eğlence',
  'gifts.category.status': 'Lüks',
  'gifts.category.pranks': 'Şakalar',
  'gifts.category.seasonal': 'Sezonluk',

  'ratings.title': 'Sıralamalar',
  'ratings.kisses': 'En çok öpülen',
  'ratings.dj': 'En iyi DJ’ler',
  'ratings.day': 'Bugün',
  'ratings.week': 'Bu hafta',
  'ratings.month': 'Bu ay',
  'ratings.all': 'Tüm zamanlar',
  'ratings.you': 'Sen',
  'ratings.empty': 'Henüz kimse yok. İlk sen ol!',

  'achievements.title': 'Başarımlar',
  'achievements.progress': '{progress} / {threshold}',
  'achievements.reward': 'Ödül: ❤ {reward}',

  'errors.VIP_REQUIRED': 'Bu VIP oyuncular için.',
  'errors.NOT_OWNED': 'Bu eşya henüz sende yok.',
  'lobby.vip': 'VIP',
  'lobby.styling': 'Stil',
  'vip.title': 'VIP statüsü',
  'vip.active_until': 'VIP {date} tarihine kadar',
  'vip.inactive': 'Her masada öne çık.',
  'vip.perk_name': 'Masada ve sohbette altın isim ve VIP rozeti',
  'vip.perk_bottle': 'Masan için VIP şişe',
  'vip.perk_frames': 'Özel VIP çerçeveler',
  'vip.perk_gifts': 'VIP hediyeler ve çıkartmalar',
  'vip.plan': '{days} gün',
  'vip.buy': '❤ {price} karşılığında al',
  'vip.extend': '❤ {price} ile uzat',
  'vip.bought': '{date} tarihine kadar VIP’sin! 👑',
  'styling.title': 'Stil',
  'styling.none': 'Stil yok',
  'styling.none_hint': 'Profil fotoğrafı ve kullanıcı adı stilsiz kalsın',
  'styling.buy': '❤ {price} karşılığında al',
  'styling.equip': 'Tak',
  'styling.equipped': 'Takılı',
  'styling.remove': 'Çıkar',
  'styling.owned': 'Senin',
  'styling.vip_only': 'Sadece VIP',
  'styling.reward.league_champion': 'Ödül: bir lig gününü kazan',
  'styling.reward.kiss_master': 'Ödül: 1000 öpücük al',
  'bottle.put': '❤ {price} karşılığında masaya koy',
  'bottle.pick': 'Bir şişe seç',
  'bottle.title': 'Şişeyi değiştir',
  'bottle.hint': 'Şişe bu masadaki herkes için değişir.',
  'bottle.current': 'Masada',
  'bottle.changed': '{name} masaya “{skin}” şişesini koydu 🍾',
  'table.change_bottle': 'Şişeyi değiştir',
  'bottle.classic': 'Klasik',
  'bottle.emerald': 'Zümrüt',
  'bottle.amber': 'Kehribar',
  'bottle.champagne': 'Şampanya',
  'bottle.cola': 'Kola',
  'bottle.lemonade': 'Limonata',
  'bottle.whisky': 'Viski',
  'bottle.wine': 'Kırmızı şarap',
  'bottle.sparkle': 'Pırıltı',
  'bottle.ice': 'Buz',
  'bottle.gold': 'Altın',
  'bottle.potion': 'Aşk iksiri',
  'bottle.baby': 'Biberon',
  'bottle.vip': 'VIP',
  'frame.rose_garden': 'Gül bahçesi',
  'frame.neon_pink': 'Neon pembe',
  'frame.neon_cyan': 'Neon turkuaz',
  'frame.hearts': 'Kalpler',
  'frame.candy': 'Şeker',
  'frame.bow': 'Fiyonk',
  'frame.leaves': 'Sonbahar',
  'frame.flame': 'Alev',
  'frame.ice': 'Buz',
  'frame.butterfly': 'Kelebek',
  'frame.emerald': 'Zümrüt',
  'frame.ruby': 'Yakut',
  'frame.sapphire': 'Safir',
  'frame.devil': 'Küçük şeytan',
  'frame.angel': 'Melek',
  'frame.galaxy': 'Galaksi',
  'frame.rainbow': 'Gökkuşağı',
  'frame.royal': 'Kraliyet',
  'frame.vip_gold': 'VIP altın',
  'frame.vip_diamond': 'VIP elmas',
  'frame.league_champion': 'Lig şampiyonu',
  'frame.kiss_master': 'Öpücük ustası',
  'stickers.title': 'Çıkartmalarım',
  'stickers.pack.basic': 'Temel',
  'stickers.pack.love': 'Aşk',
  'stickers.pack.party': 'Parti',
  'stickers.pack.animals': 'Hayvanlar',
  'stickers.pack.vip': 'VIP',
  'stickers.cost': 'Her çıkartma ❤ {price} değerinde ve avatarının üzerinde süzülür.',
  'stickers.buy': '❤ {price} karşılığında aç',
  'stickers.vip_only': 'VIP oyuncular için',
  'ratings.emotional': 'En duygusal',
  'wheel.title': 'Şans Çarkı',
  'wheel.spin': 'Çevir',
  'wheel.chances': 'Şanslar: {count}',
  'wheel.free': 'Günün bedava şansı',
  'wheel.free_taken': 'Bedava şans için yarın gel',
  'wheel.shop': 'Şans Dükkanı',
  'wheel.pack': '{count} şans',
  'wheel.pack_one': '1 şans',
  'wheel.help': 'Nasıl çalışır',
  'wheel.help_text':
    'Her çevirme bir şans harcar. Ödüller aşağıdaki olasılıklarla sunucu tarafından çekilir; kazandığın şansları yeniden harcayabilirsin. Güçlendiriciler lig ekranından kullanılır.',
  'wheel.odds': 'Olasılıklar',
  'wheel.won': 'Kazandın: {prize}',
  'wheel.jackpot_banner': '🎰 {name} büyük ikramiyeyi kazandı: {prize}!',
  'wheel.big_win_banner': '🎡 {name} çarkta {prize} kazandı',
  'wheel.need_chance': 'Şansın kalmadı: yarın bedava bir şans al ya da aşağıdan satın al.',
  'wheel.boosters': 'Güçlendiricilerim',
  'wheel.prize.hearts_3': '❤ 3',
  'wheel.prize.hearts_5': '❤ 5',
  'wheel.prize.hearts_25': '❤ 25',
  'wheel.prize.hearts_100': '❤ 100',
  'wheel.prize.jackpot': 'Büyük ikramiye ❤ 1000',
  'wheel.prize.chance_1': '+1 şans',
  'wheel.prize.chance_3': '+3 şans',
  'wheel.prize.boost_x2': 'Güçlendirici ×2',
  'wheel.prize.boost_limit': 'Güçlendirici +10 limit',
  'wheel.prize.boost_bonus': 'Güçlendirici +5 puan',
  'booster.x2': 'Lig puanlarını ikiye katla',
  'booster.x2_desc': 'Aldığın öpücükler 5 dakika boyunca iki kat sayılır (öpücük hediyeleri hariç).',
  'booster.limit': 'Lig limitini artır',
  'booster.limit_desc': 'Bugün alınan öpücüklerden gelen puan sınırı 10 artar.',
  'booster.bonus': 'Bonus lig puanları',
  'booster.bonus_desc': 'Hemen +5 lig puanı, her sınırın üzerinde.',
  'lobby.wheel': 'Çark',
  'league.title': 'Ligler',
  'league.tier.wooden': 'Tahta lig',
  'league.tier.bronze': 'Bronz lig',
  'league.tier.silver': 'Gümüş lig',
  'league.tier.gold': 'Altın lig',
  'league.tier.platinum': 'Platin lig',
  'league.tier.diamond': 'Elmas lig',
  'league.ends_in': 'Sonuçlar {h} sa {m} dk sonra',
  'league.points': '★ {points}',
  'league.kiss_limit': 'Bugünkü öpücük puanları: {used} / {cap}',
  'league.zone_up': 'Bir üst lige çık',
  'league.zone_down': 'Bir alt lige düş',
  'league.rewards': 'Ödüller',
  'league.chest.red': 'Kırmızı sandık',
  'league.chest.blue': 'Mavi sandık',
  'league.chest.wooden': 'Tahta sandık',
  'league.chest.box': 'Hediye kutusu',
  'league.chest_contents': '❤ {hearts} + 🎲 {chances}',
  'league.box_contents': '{points}+ puan için 🎲 {chances}',
  'league.place': '{place}. sıra',
  'league.empty':
    'Bir gruba katılmak için bugün ilk puanlarını kazan: hediye gönder, şarkı ısmarla, oyunculara hayran ol ya da öpücük al.',
  'league.rules': 'Kurallar',
  'league.rules_text':
    'Ligler günlük yarışmalardır. Hediyeye, müziğe ve hayranlığa harcanan her kalp ve aldığın her öpücük için (günde en fazla {cap} puan) bir puan kazanırsın. Gün sonunda her grubun ilk {promote} oyuncusu bir üst lige çıkar, son {demote} oyuncu bir alt lige düşer ({min}+ oyunculu gruplarda). İlk 3 sandık, {box}+ puanı olan herkes hediye kutusu alır.',
  'league.use': 'Kullan',
  'league.x2_active': '×2 açık: {time}',
  'league.used.x2': 'Alınan öpücükler 5 dakika boyunca iki kat sayılır!',
  'league.used.limit': 'Bugünkü öpücük limitin 10 arttı.',
  'league.used.bonus': '+5 lig puanı!',
  'league.last_result': 'Son sonuç: {tier} — {place}. sıra',
  'league.moved_up': '⬆ Yükseldi',
  'league.moved_down': '⬇ Düştü',
  'league.stayed': 'Yerinde kaldı',
  'league.result_toast': 'Lig sonuçları: {place}. sıra. {chest}',
  'league.get_boosters': 'Güçlendiricileri Şans Çarkı’nda kazan',
  'lobby.league': 'Lig',
  'achievement.kisser.title': 'Öpücükçü',
  'achievement.kisser.desc': 'Verilen öpücükler: {count}',
  'achievement.popular.title': 'Popüler',
  'achievement.popular.desc': 'Alınan öpücükler: {count}',
  'achievement.mutual.title': 'Sevgililer',
  'achievement.mutual.desc': 'Karşılıklı öpücükler: {count}',
  'achievement.spinner.title': 'Şişe ustası',
  'achievement.spinner.desc': 'Şişe çevirmeleri: {count}',
  'achievement.regular.title': 'Müdavim',
  'achievement.regular.desc': 'Oynanan turlar: {count}',
  'achievement.generous.title': 'Cömert',
  'achievement.generous.desc': 'Gönderilen hediyeler: {count}',
  'achievement.adored.title': 'Gözde',
  'achievement.adored.desc': 'Alınan hediyeler: {count}',
  'achievement.dj.title': 'DJ',
  'achievement.dj.desc': 'Ismarlanan şarkılar: {count}',
  'achievement.chatty.title': 'Geveze',
  'achievement.chatty.desc': 'Sohbet mesajları: {count}',
  'achievement.daredevil.title': 'Gözü kara',
  'achievement.daredevil.desc': 'Kabul edilen görevler: {count}',
  'achievement.streak.title': 'Sadık',
  'achievement.streak.desc': 'Art arda günlük bonus günleri: {count}',
  'achievement.emotional.title': 'Duygusal',
  'achievement.emotional.desc': 'Gönderilen çıkartmalar: {count}',
  'achievement.lucky.title': 'Şanslı',
  'achievement.lucky.desc': 'Çark çevirmeleri: {count}',
  'achievement.admirer.title': 'Hayran',
  'achievement.admirer.desc': 'Hayran olunan oyuncular: {count}',
  'achievement.charmer.title': 'Çekici',
  'achievement.charmer.desc': 'Sana hayran olunma sayısı: {count}',
  'achievement.champion.title': 'Şampiyon',
  'achievement.champion.desc': 'Kazanılan lig sandıkları: {count}',
  'achievement.league.title': 'Tırmanıcı',
  'achievement.league.desc': 'Ulaşılan lig: {count} / 5',
  'achievement.bartender.title': 'Barmen',
  'achievement.bartender.desc': 'Değiştirilen masa şişeleri: {count}',
  'achievement.secret.title': 'Gizli hayran',
  'achievement.secret.desc': 'Gönderilen gizli mesajlar: {count}',
  'ratings.expensive': 'En pahalı',
  'ratings.important': 'En önemli',
  'ratings.top': 'TOP',
  'ratings.help.kisses': 'Alınan öpücükler, öpücük hediyeleri dahil.',
  'ratings.help.dj': 'Müziğe harcanan kalpler, ayrıca şarkın çalarken aldığın her hediye için bir puan.',
  'ratings.help.expensive': 'Son hayranlık fiyatın ya da bir hayranı geri çevirdiğin fiyat.',
  'ratings.help.important':
    'Başkalarına hayranlık için harcanan kalpler; geri çevrildiğinde ya da biri seni geçtiğinde düşülür.',
  'ratings.help.emotional': 'Çıkartmalara (jestlere) harcanan kalpler.',
  'achievements.stars': '★ {stars} / {total}',
  'achievements.filter.all': 'Tümü',
  'achievements.filter.done': 'Tamamlanan',
  'achievements.filter.locked': 'Kilitli',
  'achievements.next': 'Sonraki yıldız: {progress} / {goal} · ❤ {reward}',
  'achievements.complete': 'Tüm yıldızlar kazanıldı!',
  'player.turn_down': 'Hayranı geri çevir',
  'player.turned_down': '{name} adlı hayranı geri çevirdin',
  'notify.turned_down': '{name} seni geri çevirdi',
  'activity.title': 'Bonus & Sıralama',
  'activity.today': 'Bugün',
  'activity.yesterday': 'Dün',
  'activity.time': 'Aktiflik süresi',
  'activity.time_value': '{h} sa {m} dk',
  'activity.milestone': '{hours} sa → ❤ {reward}',
  'activity.points': 'Aktiflik puanları',
  'activity.how': 'Puan kuralları',
  'activity.kind.message': 'Mesaj',
  'activity.kind.song': 'Şarkı',
  'activity.kind.booster': 'Güçlendirici',
  'activity.kind.gift': 'Hediye',
  'activity.kind.round': 'Tur',
  'activity.kind.sticker': 'Çıkartma',
  'activity.kind.wheel': 'Çark',
  'activity.rules':
    'Bir masada aktif olduğun süre sayılır (en az {gap} dakikada bir hareket). Günde en fazla {cap} sohbet mesajı puan kazandırır. Günlük sıralama gece yarısı kapanır; ilk {places} sıra kalp kazanır. Spam sayılmaz.',
  'activity.top': 'Günlük ilk {size}',
  'activity.prize': '❤ {hearts}',
  'activity.ends_in': '{h} sa {m} dk sonra kapanır',
  'activity.empty': 'Bugün henüz aktiflik yok.',
  'activity.reward_toast': 'Aktiflik ödülü: ❤ {hearts}',
  'activity.top_toast': 'Günlük aktiflik sıralaması: {place}. sıra, ❤ {hearts}',
  'lobby.bonus': 'Bonus',
  'friends.title': 'Arkadaş listesi',
  'friends.add': 'Arkadaş ekle',
  'friends.requested': 'İstek gönderildi',
  'friends.accept': 'Kabul et',
  'friends.decline': 'Reddet',
  'friends.remove': 'Arkadaşlardan çıkar',
  'friends.friends': 'Arkadaşlar',
  'friends.incoming': 'Arkadaşlık istekleri',
  'friends.outgoing': 'Gönderilen istekler',
  'friends.empty': 'Henüz arkadaşın yok.',
  'friends.online': 'çevrimiçi',
  'friends.at_table': 'masada',
  'friends.join': 'Katıl',
  'friends.count': 'Arkadaşlar: {count}',
  'friends.hidden': 'Arkadaşlar gizli',
  'friends.privacy': 'Arkadaşlarımı kim görsün',
  'friends.privacy.everyone': 'Herkes',
  'friends.privacy.me': 'Sadece ben',
  'notify.friend_request': '{name} seninle arkadaş olmak istiyor',
  'notify.friend_accepted': '{name} arkadaşlık isteğini kabul etti',
  'lobby.friends': 'Arkadaşlar',
  'settings.gender': 'Cinsiyet',
  'settings.gender_hint': 'Bunu {days} günde bir değiştirebilirsin, masada otururken değil.',
  'settings.gender_next': 'Sonraki değişiklik: {date}',
  'errors.GENDER_COOLDOWN': 'Cinsiyetini kısa süre önce değiştirdin. Daha sonra tekrar dene.',
  'errors.TOO_MANY_FRIENDS': 'Arkadaş listen dolu.',
  'errors.TRANSLATION_UNAVAILABLE': 'Çeviri şu anda kullanılamıyor.',
  'table.show_translation': 'Çeviriyi göster',
  'table.hide_translation': 'Çeviriyi gizle',
  'table.translating': 'Çevriliyor…',
  'player.league': '{league}',
  'player.send_gift_title': '{name} için hediye gönder',
  'settings.photo_change': 'Fotoğrafı değiştir',
  'settings.photo_reset': 'Telegram fotoğrafımı kullan',
  'settings.photo_hint':
    'Kendi fotoğrafını yükleyene kadar Telegram fotoğrafın kullanılır. Uygunsuz fotoğraflar kaldırılır ve hesabın engellenebilir.',
  'settings.photo_preview': 'Yeni fotoğraf',
  'settings.photo_saved': 'Fotoğraf güncellendi',
  'settings.name_reset': 'Telegram adımı kullan',
  'errors.UNSUPPORTED_IMAGE': 'Bu görsel kullanılamaz. Başka bir fotoğraf dene.',
  'lobby.domino': 'Domino',
  'domino.title': 'Domino',
  'domino.rules': 'Pazarlı klasik domino · {target} puana ilk ulaşan potu alır',
  'domino.rake': 'Kasa payı %{percent}',
  'domino.quick': 'Hızlı oyun',
  'domino.free': 'Bedava',
  'domino.create': 'Oda aç',
  'domino.seats': 'Oyuncular',
  'domino.stake_label': 'Bahis',
  'domino.open_rooms': 'Oyuncu bekleyen odalar',
  'domino.no_rooms': 'Henüz açık oda yok: bir oda aç ya da hızlı oyuna başla.',
  'domino.join': 'Katıl',
  'domino.back_to_game': 'Bir odadasın: oyuna dön',
  'domino.waiting': 'Oyuncular bekleniyor… {n}/{seats}',
  'domino.leave': 'Ayrıl',
  'domino.leave_confirm': 'Oyundan ayrılıyor musun? Kaybedersin ve bahsin potta kalır.',
  'domino.leave_refund': 'Odadan ayrıl (bahsin iade edilir)',
  'domino.pot': 'Pot ❤ {pot}',
  'domino.round': 'Tur {round} · hedef {target}',
  'domino.your_turn': 'Sıra sende',
  'domino.turn_of': '{name} oynuyor',
  'domino.draw': 'Çek ({n})',
  'domino.pass': 'Pas',
  'domino.choose_end': 'Hangi uç?',
  'domino.left': '◀ Sol',
  'domino.right': 'Sağ ▶',
  'domino.boneyard': 'Pazar {n}',
  'domino.drew': '{name} {n} taş çekti',
  'domino.passed': '{name} pas geçti',
  'domino.auto': '{name} için süre doldu',
  'domino.round_won': '{name} turu kazandı: +{points}',
  'domino.round_blocked': 'Kilitlendi! En düşük el: {name}, +{points}',
  'domino.round_tie': 'Beraberlikle kilitlendi: bu tur puan yok',
  'domino.next_round': 'Sonraki tur {s} sn sonra',
  'domino.game_won': '{name} oyunu kazandı!',
  'domino.you_won': '❤ {payout} kazandın!',
  'domino.out': 'elendi',
  'domino.to_lobby': 'Odalara dön',
  'domino.cancelled': 'Oda kapandı; bahisler iade edildi.',
  'domino.started': 'Domino oyunun başladı!',
  'domino.points': '{score} puan',
  'domino.empty_seat': 'Boş koltuk',
  'domino.first_move': 'Vurgulanan çiftle başla',
  'errors.ILLEGAL_MOVE': 'Bu taş oraya uymuyor.',
  'errors.DOMINO_DISABLED': 'Domino kullanılamıyor.',
  'errors.ALREADY_IN_GAME': 'Zaten bir domino odasındasın.',
  'lobby.live': 'Canlı',
  'live.title': 'Canlı',
  'live.go_live': 'Canlı yayına başla',
  'live.vip_only': 'Canlı yayını VIP oyuncular açar; herkes izleyebilir.',
  'live.connect_failed':
    'Yayının videosuna bağlanılamadı. İnternetini kontrol et (ya da mobil veriyi dene) ve tekrar aç.',
  'live.no_webrtc':
    'Bu Telegram uygulaması canlı videoyu oynatamıyor. Oyunu telefondaki Telegram’da ya da web.telegram.org’da aç.',
  'live.empty': 'Şu anda kimse canlı yayında değil.',
  'live.viewers': '{n} izliyor',
  'live.start_title': 'Senin yayının',
  'live.title_placeholder': 'Yayının ne hakkında?',
  'live.rules':
    '18 yaşından büyüğüm. Çıplaklık veya reşit olmayanları göstermeyeceğim ve iletişim bilgisi paylaşmayacağım. Kuralları ihlal etmek yayını bitirir ve hesabın engellenmesine yol açabilir.',
  'live.start': 'Yayını başlat',
  'live.camera_needed': 'Canlı yayın için kameraya ve mikrofona izin ver',
  'live.end': 'Yayını bitir',
  'live.end_confirm': 'Yayını şimdi bitirmek istiyor musun?',
  'live.ended': 'Yayın sona erdi',
  'live.ended_reports': 'Yayın şikayetler üzerine sonlandırıldı',
  'live.ended_admin': 'Bir yönetici yayını sonlandırdı',
  'live.ended_lost': 'Yayıncının bağlantısı koptu',
  'live.back': 'Yayınlara dön',
  'live.chat_placeholder': 'Güzel bir şey yaz…',
  'live.sent_gift': '{name} {emoji} gönderdi',
  'live.report': 'Şikayet et',
  'live.reported': 'Teşekkürler, yöneticiler inceleyecek.',
  'live.tap_sound': '🔊 Ses için dokun',
  'live.connecting': 'Bağlanıyor…',
  'live.gift_title': '{name} için hediye',
  'live.you_are_live': 'Canlı yayındasın',
  'live.waiting_video': 'Video bekleniyor…',
  'live.like': 'Beğen',
  'live.gift': 'Hediye',
  'live.camera': 'Kamera',
  'live.admin_tab': 'Canlı',
  'live.admin_end': 'Bitir',
  'live.admin_reports': '{n} şikayet',
  'live.admin_none': 'Henüz yayın yok.',
  'errors.LIVE_DISABLED': 'Canlı yayınlar kullanılamıyor.',
  'errors.ALREADY_LIVE': 'Zaten canlı yayındasın.',
  'errors.STREAM_ENDED': 'Yayın bitti.',

  'settings.title': 'Ayarlar',
  'settings.sound': 'Sesler',
  'settings.music': 'Müzik',
  'settings.notifications': 'Gizli mesajları botta bildir',
  'settings.language': 'Dil',
  'settings.name': 'Masadaki adın',
  'settings.birth_year': 'Doğum yılı',
  'settings.blocked': 'Engellenen oyuncular',
  'settings.support': 'Destek',
  'settings.saved': 'Kaydedildi',

  'invite.title': 'Arkadaşlarını davet et',
  'invite.text': 'Arkadaşın ilk turunu oynadığında ikiniz de ❤ {bonus} alırsınız.',
  'invite.share': 'Davet bağlantısını paylaş',
  'invite.copy': 'Bağlantıyı kopyala',
  'invite.copied': 'Bağlantı kopyalandı',
  'invite.stats': 'Davet edilen: {invited} · Ödül alınan: {rewarded}',
  'invite.share_text': 'Spin the Bottle’da bana katıl! 🍾💋',

  'notify.admired': '{name} ❤ {price} ile sana hayran oldu',
  'notify.outbid': '{name}, {target} için hayranlıkta seni geçti',
  'notify.gift': '{name} sana {emoji} gönderdi',
  'notify.achievement': 'Başarım: {title} ★{level} (+❤ {reward})',
  'notify.referral': '+❤ {bonus}: {name} davetinle oyuna katıldı!',
  'notify.wallet': '+❤ {amount}',
  'notify.gm': '💰 +{amount} GM',
  'notify.transfer_gm': '{name} sana {amount} GM gönderdi',
  'notify.transfer_hearts': '{name} sana ❤ {amount} gönderdi',

  'admin.live_reported': '🔴 {name} adlı oyuncunun canlı yayını {reports} şikayetten sonra sonlandırıldı.',
  'admin.auto_mute': '⚠️ Otomatik susturma: {userId} oyuncusu 24 saatte {reports} şikayet aldı.',
  'admin.broadcast_done': '📣 Toplu mesaj tamamlandı: gönderilen {sent}, başarısız {failed}.',

  'bot.welcome':
    'Selam! En iyi Spin the Bottle macerasına dalmaya hazır ol.\n\n👀 Etrafındakileri gör ve sohbete başla\n🎁 Eğlenceli sürprizler ve cesaret görevleri paylaş\n💌 Özel birine gizli mesajlar gönder\n🎲 Odada birlikte eğlenceli oyunların tadını çıkar\n🎶 Arka planda çalan müzikle birlikte oyna\n\n🎮 PLAY’e dokun ve eğlence başlasın!',
  'bot.play_button': '🎮 PLAY',
  'bot.menu_button': 'PLAY',
  'bot.help': 'Spin the Bottle, Mini App’te oynanır: 🎮 PLAY’e dokun.',
  'bot.rate_limited': 'Çok fazla istek. Biraz yavaşla.',
  'bot.banned': 'Hesabın engellendi.',
  'bot.gm_credited': '💰 Hesabına +{amount} GM yüklendi. Bakiye: {gm} GM',
  'bot.gm_debited': '💰 Bir yönetici hesabından {amount} GM düştü. Bakiye: {gm} GM',
  'bot.short_description': 'Şişeyi çevir, öpüş, hediye gönder ve müzik aç 💋',
  'bot.description':
    'Telegram’da klasik Spin the Bottle parti oyunu: 12 kişilik masalar, öpücükler, hediyeler, ligler, Şans Çarkı ve müzik. 18+.',
  'bar.heart_shop': 'Kalp dükkanı',
  'bar.wheel': 'Şans Çarkı',
  'bar.league': 'Lig',
  'bar.misc': 'Diğer',
  'bar.settings': 'Ayarlar',
  'bar.exit': 'Çıkış',
  'bar.table': 'Masa',
  'bar.change_table': 'Masayı değiştir',
  'menu.achievements': 'Başarımlar',
  'menu.ratings': 'Sıralamalar',
  'menu.bottle': 'Şişe',
  'menu.styling': 'Stil',
  'menu.boosters': 'Güçlendiriciler',
  'table.spin_the_bottle': 'Şişeyi çevir!',
  'table.spins_the_bottle': 'Şişeyi çeviriyor',
  'table.order_song': '❤ {price} karşılığında şarkı ısmarla',
  'table.order_video': '❤ {price} karşılığında klip ısmarla',
  'table.video_size': 'Video boyutu',
  'table.play_here': 'Burada oyna',
  'gifts.send_to': 'Hediye gönder',
  'player.profile': 'Profil',
  'player.admire_for': 'Hayran ol',
  'player.reported': 'Teşekkürler, inceleyeceğiz.',
  'report.SPAM': 'Spam',
  'report.ABUSE': 'Hakaret',
  'report.SEXUAL_CONTENT': 'Cinsel içerik',
  'report.UNDERAGE': '18 yaşından küçük',
  'report.OTHER': 'Diğer',
  'shop.title': 'Kalp satın al',
  'shop.details': 'Detaylar',
  'shop.vip_status': 'STATÜ',
  'shop.for_friend_1': 'Arkadaş için',
  'shop.for_friend_2': 'kazan',
  'shop.bonus': '%{percent} BONUS',
  'shop.best_offer': 'En iyi teklif',
  'shop.best_pick': 'En iyi seçim',
  'shop.send': 'Gönder',
  'shop.need_gm': '{gm} GM gerekiyor. GM bakiyeni yüklemek için yöneticiye yaz.',
  'shop.bought': '+❤ {hearts}',
  'shop.send_gm_title': 'Arkadaşına GM {amount} gönder',
  'shop.send_hearts_title': 'Arkadaşına ❤ {amount} gönder',
  'shop.send_left': 'Bugün kalan gönderim: {count}',
  'shop.send_no_friends': 'Önce arkadaş ekle: masadaki bir oyuncuya dokun, sonra yeşil +.',
  'shop.sent_gm': '{name} için {amount} GM gönderildi',
  'shop.sent_hearts': '{name} için ❤ {amount} gönderildi',
  'vip.perks': 'VIP ol: eşsiz hediyeler gönder, emojileri kullan ve özel isim rengiyle herkesten öne çık!',
  'wheel.rules': '“Çevir”e dokun — Şans Çarkı’nı başlat ve ödülünü al!',
  'wheel.chances_label': 'Şanslar:',
  'wheel.price': 'Fiyat:',
  'wheel.winner': 'Kazanan',
  'wheel.jackpot_text': 'büyük ikramiyeyi vurdu ve ❤ 1000 kazandı',
  'wheel.big_win_text': '{prize} kazandı',
  'league.hint': 'Üst sıralara çıkmak için güçlendiricileri kullan',
  'league.boosters': 'Güçlendiriciler',
  'league.zone_up_hint': 'üst lige geçiş',
  'league.final_in': 'Sonuçlar: {hours} sa. sonra',
  'league.until_limit': 'Limite kadar:',
  'league.activate': 'Etkinleştir',
  'league.rules_1': 'Ligler, kalp ve eşsiz hediyeler kazanabileceğin günlük yarışmalardır.',
  'league.rules_2':
    'Puanlar hediyeler, alınan öpücükler, çalınan müzik ve hayranlık için verilir. Harcanan her kalp için bir puan: ne kadar çok hediye gönderirsen o kadar çok puan kazanırsın.',
  'league.rules_3':
    'Gün sonunda ilk {promote} oyuncu bir üst lige çıkar ve sandık alır; son {demote} oyuncu bir alt lige düşer.',
  'league.rules_4':
    'Alınan öpücükler günde en fazla {cap} puan verir. Şans Çarkı’ndaki güçlendiriciler yardımcı olur: iki kat puan, daha yüksek limit ve bonus puanlar.',
  'achievements.mine': 'Başarımlarım',
  'achievements.count': '{stars}/{total}',
  'achievements.show_first': 'Önce göster:',
  'achievements.completed': 'tamamlanan',
  'achievements.locked': 'kilitli',
  'achievements.detail': 'Başarım',
  'achievements.meet': 'Kazanmak için koşulları yerine getir:',
  'ratings.help_title': 'Bu sıralama hakkında',
  'ratings.period': 'Dönem',
  'ratings.top_n': 'En iyi {n} oyuncu',
  'ratings.period_all': 'tüm zamanlar',
  'ratings.period_month': 'bu ay',
  'ratings.period_week': 'bu hafta',
  'ratings.period_day': 'bugün',
  'styling.apply': 'Uygula',
  'styling.owned_hint': 'Bu çerçeve senin.',
  'styling.buy_hint': 'Bu çerçeveyi ❤ {price} karşılığında al ve tak.',
  'styling.locked': 'Bu çerçeve bir ödül.',
  'settings.sounds': 'Sesler',
  'settings.invite': 'Arkadaşlarını davet et',
  'settings.friends': 'Arkadaşlarım',
  'settings.contact': 'Bize ulaş',
  'friends.who_sees': 'Arkadaşlıklarımı kimler görsün?',
  'friends.visibility_everyone': 'Herkes',
  'friends.visibility_me': 'Sadece ben',
  'friends.sent': 'Gönderilen istekler: {count}',
  'activity.hours': '{hours} saat',
  'activity.more': 'DAHA FAZLA',
  'activity.less': 'DAHA AZ',
  'activity.h': 'sa',
  'activity.m': 'dk',
  'activity.pts': '{points} puan',
  'activity.my_place': 'Senin sıran: #{rank} · {points} puan',
  'portal.logout': 'Çıkış',
  'portal.services': 'Hizmetler',
  'portal.invited': 'Davet edilenler',
  'portal.invited_empty': 'Henüz bağlantınla kimse katılmadı.',
  'portal.no_status': 'Henüz durum yok',
  'portal.status_title': 'Durumun',
  'portal.status_placeholder': 'Kendin hakkında bir şeyler yaz…',
  'portal.start': 'Başla',
  'portal.watch': 'İzle',
  'portal.license': 'Lisans',
  'portal.license_title': '{name} v2',
  'portal.license_text':
    '© {year}. Tüm hakları saklıdır. Öpücükler ve hediyeler sanaldır, sadece eğlence için.',
  'services.store': 'Mağaza',
  'services.balance': 'Bakiye:',
  'services.username': 'Kullanıcı adı',
  'services.game_name': 'Oyun adı',
  'services.profile': 'Profil',
  'services.password': 'Şifreyi değiştir',
  'services.password_text': 'Hesap şifreni değiştir.',
  'services.gender': 'Cinsiyeti değiştir',
  'services.gender_text': 'Cinsiyet bilgini değiştir.',
  'services.name': 'Oyun adını değiştir',
  'services.name_text': 'Oyunlarda görünen adı değiştir.',
  'services.photo': 'Profil fotoğrafını değiştir',
  'services.photo_text': 'Profil fotoğrafını özelleştir.',
  'services.back': 'GERİ',
  'services.password_current': 'Mevcut şifre',
  'services.password_new': 'Yeni şifre (en az 6 karakter)',
  'services.password_repeat': 'Yeni şifreyi tekrarla',
  'services.password_hint': 'Şifreyle sitede ID’nle giriş yapabilirsin.',
  'services.password_mismatch': 'Şifreler eşleşmiyor.',
  'services.password_saved': 'Şifre kaydedildi.',
  'services.gender_later': '{date} tarihinden sonra tekrar değiştirebilirsin.',
  'services.name_telegram': 'Telegram adımı kullan ({name})',
  'services.photo_pick': 'Fotoğraf seç',
  'services.photo_telegram': 'Telegram fotoğrafımı kullan',
  'login.title': 'Giriş yap',
  'login.login': 'ID veya @username',
  'login.password': 'Şifre',
  'login.submit': 'Giriş yap',
  'login.hint': 'Şifreyi oyunda belirle: çıkış → Hizmetler → Şifreyi değiştir.',
  'login.open_bot': 'Oyunu Telegram’da aç',
  'login.developer': 'Geliştirici girişi',
  'watch.back': 'Geri',
  'watch.live_caps': 'CANLI',
  'watch.live_tab': 'Canlı ({count})',
  'watch.domino_tab': 'Domino ({count})',
  'watch.no_streams': 'Aktif yayın bulunamadı.',
  'watch.first_stream': 'İlk Yayını Başlat',
  'live.no_other_camera': 'Başka kamera yok.',
  'courting.title': 'Hayranlık',
  'courting.text': '{name} sana hayran oldu —',
  'courting.ok': 'Tamam',

  // Daily horoscope (menu ≡ → Horoscope).
  'menu.horoscope': 'Burçlar',
  'horoscope.title': 'Günlük burç yorumu',
  'horoscope.pick': 'Burcunuzu seçin',
  'horoscope.today': 'Bugün, {date}',
  'horoscope.love_title': 'Aşk',
  'horoscope.lucky_number': 'Şanslı sayı',
  'horoscope.lucky_color': 'Şanslı renk',
  'horoscope.change': 'Burcu değiştir',
  'portal.credits': '3D görseller: Microsoft Fluent Emoji (MIT). Burç sembolleri: Freepik.',
  'horoscope.sign.aries': 'Koç',
  'horoscope.sign.taurus': 'Boğa',
  'horoscope.sign.gemini': 'İkizler',
  'horoscope.sign.cancer': 'Yengeç',
  'horoscope.sign.leo': 'Aslan',
  'horoscope.sign.virgo': 'Başak',
  'horoscope.sign.libra': 'Terazi',
  'horoscope.sign.scorpio': 'Akrep',
  'horoscope.sign.sagittarius': 'Yay',
  'horoscope.sign.capricorn': 'Oğlak',
  'horoscope.sign.aquarius': 'Kova',
  'horoscope.sign.pisces': 'Balık',
  'horoscope.general.0': 'Yeni tanışmalar için güzel bir gün. İlk selamı siz verin.',
  'horoscope.general.1': 'Bugün enerjiniz yüksek. Şişeyi birkaç kez çevirin!',
  'horoscope.general.2': 'Masadaki biri sizi düşünüyor.',
  'horoscope.general.3': 'Bugün hafif olun: bir şaka ciddi bir sohbetten daha çok kapı açar.',
  'horoscope.general.4': 'Bugün küçük bir hediye büyük bir etki bırakabilir.',
  'horoscope.general.5': 'İlk izleniminize güvenin, bugün sizi yanıltmayacak.',
  'horoscope.general.6': 'Sakin bir gün. Müziğin ve sohbetin tadını çıkarın.',
  'horoscope.general.7': 'Bugün şans cesurlardan yana. İlk adımı atın.',
  'horoscope.general.8': 'Eski bir arkadaşınız bugün sizi şaşırtabilir.',
  'horoscope.general.9': 'Bugün sabır karşılığını verecek. Akşama istediğinize ulaşacaksınız.',
  'horoscope.love.0': 'Bugünkü öpücük özel bir şeyin başlangıcı olabilir.',
  'horoscope.love.1': 'Bugün gülümsemeniz en güzel hediye.',
  'horoscope.love.2': 'Biri size gizlice hayran. Masaya bir bakın.',
  'horoscope.love.3': 'Duygularınızı açıkça söyleyin, bu takdir edilecek.',
  'horoscope.love.4': 'Bugün karşılıklı öpücük ihtimali çok yüksek.',
  'horoscope.love.5': 'Acele etmeyin: en güzel şeyler zamanla gelir.',
  'horoscope.color.0': 'Kırmızı',
  'horoscope.color.1': 'Pembe',
  'horoscope.color.2': 'Altın',
  'horoscope.color.3': 'Mavi',
  'horoscope.color.4': 'Yeşil',
  'horoscope.color.5': 'Mor',
};
